// Syft ACP - Atoms <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import BaseIcon from './base/BaseIcon'

const CheckIcon = () => <BaseIcon iconSlug="person" iconAlt="Person" iconSize={11} />

export default CheckIcon
